import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import ModalContactSuccess from "../../Modals/ModalContactSuccess";

import PInput from "../../../components/PInput";
import PButton from "../../../components/PButton";
import PTextArea from "../../../components/PTextArea";
import Loading from "../../../components/Loading";
import {
  Container,
  FormWrapper,
  Title,
  ElementWrap,
  InlineElements,
  ContactFormWrap,
  BtnWrap,
} from "./styled";
import { defaultFormValues } from "./_form";
import { sendContactRequestAction } from "../../../redux/actions/send-contact.actions";
import { eventFormSubmission } from "../../../services/analytics/ga4CustomEvents";
import { validateEmail } from "../../../utils/emailValidation";
import pNotification from "../../../components/PNotification"

const ScheduleForm = ({ theme, refInstance, formType, title }) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const { loading } = useSelector(({ sentContactData }) => sentContactData);
  const [formValues, setFormValues] = useState(defaultFormValues);
  const [emailErr, setEmailErr] = useState(false);

  const handleChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setFormValues({
      ...formValues,
      [key]: value,
    });

  };

  const sendPixelInfo = async (data) => {
    const response = await fetch("/api/crm/fb-conversion", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({ ...data, "event_time": new Date().toUTCString() })
    })
    console.log(await response.json())
  }

  const handleSubmit = () => {
    if ((formValues.first_name !== "") &&
      validateEmail(formValues.email) &&
      (formValues.phone !== "")) {
      sendPixelInfo(formValues);
      dispatch(sendContactRequestAction(formValues));
      setFormValues(defaultFormValues)
      setTimeout(() => {
        setShowModal(true)
      }, 400)

      eventFormSubmission("Schedule Appointment Form Submission", "schedule");
    }
    else {
      pNotification({
        type: "error",
        message: "Failed to submit!",
        description:
          "Please include Name, Email, and Phone!",
      })
    }
  };

  return (
    <Container ref={refInstance}>
      <FormWrapper>
        <Title>
          {title || "Schedule a FREE in-home consultation today!"}
        </Title>
        <ContactFormWrap>
          <InlineElements>
            <ElementWrap>
              <PInput
                name="first_name"
                placeholder="First Name*"
                aria-label={"first name"}
                onChange={handleChange}
                value={formValues.first_name}
              />
            </ElementWrap>
          </InlineElements>

          <InlineElements>
            <ElementWrap>
              <PInput
                name="last_name"
                aria-label={"last name"}
                placeholder="Last Name"
                onChange={handleChange}
                value={formValues.last_name}
              />
            </ElementWrap>
          </InlineElements>

          <InlineElements>
            <ElementWrap>
              <PInput
                name="email"
                vType="email"
                aria-label={"email"}
                placeholder="Email*"
                onChange={handleChange}
                value={formValues.email}
                setElmInputErr={setEmailErr}
              />
            </ElementWrap>
          </InlineElements>

          <InlineElements>
            <ElementWrap>
              <PInput
                name="phone"
                aria-label={"phone"}
                placeholder="Phone"
                onChange={handleChange}
                value={formValues.phone}
              />
            </ElementWrap>
          </InlineElements>

          <InlineElements>
            <ElementWrap>
              <PInput
                name="city"
                aria-label={"city"}
                placeholder="City"
                onChange={handleChange}
                value={formValues.city}
              />
            </ElementWrap>
            <ElementWrap>
              <PInput
                name="state"
                aria-label={"state"}
                placeholder="State"
                onChange={handleChange}
                value={formValues.state}
              />
            </ElementWrap>
          </InlineElements>

          <ElementWrap>
            <PTextArea
              name="notes"
              aria-label={"comments"}
              minHeight="90px"
              placeholder="How Can We Help?"
              onChange={handleChange}
              value={formValues.notes}
            />
          </ElementWrap>
          <ElementWrap>
            <PInput
              onChange={handleChange}
              value={formValues.referral_code}
              name="referral_code"
              placeholder="Referral Code (Optional)"
            />
          </ElementWrap>
          <ElementWrap ptop="12px">
            <BtnWrap>
              <PButton
                ptype="primary"
                pname="GET STARTED"
                aria-label={"GET STARTED"}
                width="100%"
                bgColor={theme.colors.prune}
                hoverBgColor={theme.colors.hoverColor2}
                height="40px"
                shadow="yes"
                onClick={handleSubmit}
              />
            </BtnWrap>
          </ElementWrap>
        </ContactFormWrap>
      </FormWrapper>
      <Loading loading={loading} />
      <ModalContactSuccess visible={showModal} onRequestClose={() => setShowModal(false)} />
    </Container>
  );
};

ScheduleForm.propTypes = {
  formType: PropTypes.string,
  title: PropTypes.string,
};

ScheduleForm.defaultProps = {
  formType: "default",
};

export default withTheme(ScheduleForm);
